import { Button, Icon } from '@platform/components';
import { ROUTES } from '../../routes/consts';

export const BackToMyProjectsButton = () => {
  return (
    // {/* Re-visit icon button component */}
    <Button
      variant='link-color'
      size='lg'
      additionalClassnames='w-fit'
      href={`/dashboard${ROUTES.MY_PROJECTS}`}
    >
      <Icon type='arrow-left' />
      Back
    </Button>
  );
};
